import { setRequesterDefaultConfig, addRequestInterceptor } from '@/js/libs/api';

const urls = [
  '/api/ws-translate/translations-list',
  '/api/ws-translate/translations-aggregated',
  '/api/ws-translate/translation/add-missing',
  '/api/ws-translate/missing-translation',
];

// refs: #7448
// TODO migrate to runWhen parameter once released in axios
export function onTranslationListOrAddMissing(url?: string) {
  return urls.some((u) => url?.includes(u));
}

addRequestInterceptor({
  onFulfilled: async (request) => {
    if (onTranslationListOrAddMissing(request.url)) {
      request.baseURL = import.meta.env.VITE_CONSOLE_PROD_ENDPOINT;
    }
    return request;
  },
});

setRequesterDefaultConfig({
  baseURL: import.meta.env.VITE_TARGET_ENDPOINT,
});
